import { render, staticRenderFns } from "./quiz-height-calculator.vue?vue&type=template&id=8857cb64"
import script from "./quiz-height-calculator.vue?vue&type=script&lang=js"
export * from "./quiz-height-calculator.vue?vue&type=script&lang=js"
import style0 from "./quiz-height-calculator.vue?vue&type=style&index=0&id=8857cb64&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports